export const viewTitle = "Справочник фондов";
export const viewUniqKey = "fund";
